import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addItem, selectCartItemById } from "../../redux/slices/cartSlice";
import { RootState } from "../../redux/store";
import { Link } from "react-router-dom";
import { CartItemType } from "../../pages/Cart/CartItem";

export type PizzaBlockType = {
  id: string;
  imageUrl: string;
  types: number[];
  sizes: number[];
  category?: number;
  rating?: number;
  title: string;
  price: number;
  count: number;
};

enum pizzaPlate {
  "тонкое",
  "традиционное",
}

export const PizzaBlock: React.FC<PizzaBlockType> = ({
  title,
  price,
  types,
  sizes,
  imageUrl,
  id,
  count,
}) => {
  const dispatch = useDispatch();
  const cartItem = useSelector<RootState, CartItemType | undefined>(
    selectCartItemById(id)
  );
  const [plate, setPlate] = React.useState(0);
  const [activeSize, setActiveSize] = React.useState(0);

  const addedCount = cartItem ? cartItem.count : 0;
  const choosePlate = (index: number) => {
    setPlate(index);
  };
  const chooseSize = (index: number) => {
    setActiveSize(index);
  };
  const onClickAdd = () => {
    const item: CartItemType = {
      id,
      title,
      price,
      imageUrl,
      type: pizzaPlate[plate],
      size: sizes[activeSize],
      count,
    };
    dispatch(addItem(item));
  };

  return (
    <div className="pizza-block-wrapper">
      <div className="pizza-block">
        <Link to={`/pizza/${id}`}>
          <img className="pizza-block__image" src={imageUrl} alt={title} />
          <h4 className="pizza-block__title">{title}</h4>
        </Link>
        <div className="pizza-block__selector">
          <ul>
            {types.map((item, index) => {
              return (
                <li
                  key={index}
                  className={plate === index ? "active" : ""}
                  onClick={() => choosePlate(index)}
                >
                  {pizzaPlate[item]}
                </li>
              );
            })}
          </ul>
          <ul>
            {sizes.map((size, index) => {
              return (
                <li
                  key={index}
                  className={activeSize === index ? "active" : ""}
                  onClick={() => chooseSize(index)}
                >
                  {size} см
                </li>
              );
            })}
          </ul>
        </div>
        <div className="pizza-block__bottom">
          <div className="pizza-block__price">от {price} ₽</div>
          <button
            onClick={onClickAdd}
            className="button button--outline button--add"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.8 4.8H7.2V1.2C7.2 0.5373 6.6627 0 6 0C5.3373 0 4.8 0.5373 4.8 1.2V4.8H1.2C0.5373 4.8 0 5.3373 0 6C0 6.6627 0.5373 7.2 1.2 7.2H4.8V10.8C4.8 11.4627 5.3373 12 6 12C6.6627 12 7.2 11.4627 7.2 10.8V7.2H10.8C11.4627 7.2 12 6.6627 12 6C12 5.3373 11.4627 4.8 10.8 4.8Z"
                fill="white"
              />
            </svg>
            <span>Добавить</span>
            {addedCount > 0 && <i>{addedCount}</i>}
          </button>
        </div>
      </div>
    </div>
  );
};
